import React, { useEffect, useState } from 'react';

import {
  AddMemberToConversationModal,
  MentionMemberModal,
} from '../../../common/components/Mentions';
import mobxInjectSelect from '../../../common/utils/mobxInjectSelect';
import {
  AddMemberToVideoCall,
  AlertDetailsModal,
  AllowedSenderModal,
  AlwaysEscalateModal,
  CancelEscalationModal,
  CreateAppointmentModal,
  CreateSuccessModal,
  CreateOrEditCustomDirectoriesModal,
  DeleteAppointmentModal,
  DeleteBroadcastList,
  DeleteBroadcastListModal,
  DeleteConversationModal,
  DeleteTeamModal,
  DeleteTemplateModal,
  DeleteScheduledMessageModal,
  DuplicateContactModal,
  EscalationEnabledModal,
  FailureModal,
  GoModal,
  GroupMessageStatusModal,
  JoinForumModal,
  LeaveTeamModal as OldLeaveTeamModal,
  MessageDeleteModal,
  MessageForwardModal,
  MessageInfoModal,
  MessageRecallModal,
  MuteModal,
  NewGroupModal,
  PatientDeleteModal,
  PatientForwardSuccessModal,
  PatientSaveSuccessModal,
  PatientsSubmittedCSVModal,
  PriorityMessageModal,
  RejectedFileFormatModal,
  RejectedFileSizeModal,
  RemoveEscalationGroupModal,
  RemovePatientBroadcastListMember,
  RemoveRoleOrUserLineModal,
  SuccessModal,
  SupportedFileTypesModal,
  SukiModal,
  PatientAdminFailureModal,
  VisitorCallModal,
} from 'common/components';
import AddADSyncModal from 'common/components/BroadcastListSettings/AddADSyncModal';
import {
  AssignedRoleModal,
  RemovedFromRoleModal,
  TookOverRoleModal,
} from 'common/components/Roles/Modals';
import {
  ClearRolesSchedulerModal,
  DeleteEntityModal,
  DeleteTagModal,
  ErrorModal,
  EscalationModal,
  OnDutyModal,
  OptInModal,
  PagerModal,
  RemovePagerModal,
  RemoveTagModal,
  RoleEditorHandoffWarningScreenModal,
  RolesSchedulerModal,
  TagModal,
  TagSelectorModal,
  LeaveTeamModal,
} from 'common/components/Collaboration/Modals';
import {
  CallActionModal,
  CalleeBusyModal,
  ConfirmCallModal,
  EnableBrowserPermissionsModal,
  JoinVoipCallErrorModal,
  NoCameraConnectionModal,
  UnsupportedBrowserModal,
  CalleePermissionsModal,
  CalleeCapabilitiesModal,
  CalleeDndEnabledModal,
  CalleeUnavailableModal,
} from 'common/components/Call';
import {
  ScheduleMessageReviewModal,
  EditScheduleMessageModal,
  ScheduleMessageModal,
} from 'common/components/ScheduleMessageModal';
import { PatientBroadcastCsvFailModal } from 'common/components/PatientSettings/PatientBroadcastLists';
import { QuickReplyModal } from 'common/components/MessageForm';
import { MessageAttachmentModal } from 'common/components/MessageItem';
import { LeaveGroupModal } from 'common/components/GroupEditor';
import {
  ContactDeleteModal,
  CreatePatientModal,
  FailureUpdateModal,
  ManagePatientOrContactModal,
  NewPatientCsvModal,
  PatientCsvFailModal,
  UploadPBXLinesModal,
  CSVSubmittedModal,
  UploadPatientsCsvModal,
} from 'common/components/PatientSettings/PatientsList/Modals';
import {
  AutoForwardModal,
  CustomDndMessageModal,
  CustomDndTimeModal,
  ForceLogoutModal,
  LogoutModal,
  WrongPasswordModal,
} from 'common/components/Profile/Modals';
import {
  PatientReferenceSelectModal,
  PatientReferenceDetailsModal,
} from 'common/components/PatientContext';
import { AddCareTeamModal } from 'common/components/AddCareTeamModal';
import { EulaModal } from 'common/components/EulaModal';
import { PatientProfileModal } from 'common/components/PatientProfileModal';
import SecurityRiskModal from 'admin/pages/OrgSettings/Modals/SecurityRiskModal';
import OrgSettingEnabledModal from 'admin/pages/OrgSettings/Modals/OrgSettingEnabledModal';
import ManageLocationsModal from 'common/components/Locations/ManageLocationsModal';

import { ReactElementDict } from 'types';
import { actions, useAppDispatch, useAppSelector } from 'redux-stores';

const { setMessageBodyInputFocus, setModal } = actions;

const COMPONENT_BY_TYPE: ReactElementDict = {
  addADSync: AddADSyncModal,
  addCareTeamModal: AddCareTeamModal,
  addMemberToConversation: AddMemberToConversationModal,
  addMemberToVideoCall: AddMemberToVideoCall,
  alertDetails: AlertDetailsModal,
  allowedSenderModal: AllowedSenderModal,
  alwaysEscalate: AlwaysEscalateModal,
  assignedRoleModal: AssignedRoleModal,
  autoForwardModal: AutoForwardModal,
  callAction: CallActionModal,
  calleeBusy: CalleeBusyModal,
  calleeCapabilities: CalleeCapabilitiesModal,
  calleeDndEnabled: CalleeDndEnabledModal,
  calleePermissions: CalleePermissionsModal,
  calleeUnavailable: CalleeUnavailableModal,
  callUnsupported: UnsupportedBrowserModal,
  cancelEscalation: CancelEscalationModal,
  clearScheduler: ClearRolesSchedulerModal,
  confirmCall: ConfirmCallModal,
  contactDelete: ContactDeleteModal,
  createAppointment: CreateAppointmentModal,
  createOrEditCustomDirectories: CreateOrEditCustomDirectoriesModal,
  createPatient: CreatePatientModal,
  createSuccessModal: CreateSuccessModal,
  csvSubmitted: CSVSubmittedModal,
  customDndMessage: CustomDndMessageModal,
  customDndTime: CustomDndTimeModal,
  deleteAppointment: DeleteAppointmentModal,
  deleteBroadcastList: DeleteBroadcastListModal,
  deleteConversation: DeleteConversationModal,
  deleteEntity: DeleteEntityModal,
  deleteScheduledMessage: DeleteScheduledMessageModal,
  deleteSelectedBroadcastListItems: DeleteBroadcastList,
  deleteTag: DeleteTagModal,
  deleteTeam: DeleteTeamModal,
  deleteTemplate: DeleteTemplateModal,
  duplicateContact: DuplicateContactModal,
  editScheduleMessage: EditScheduleMessageModal,
  enableBrowserPermissions: EnableBrowserPermissionsModal,
  error: ErrorModal,
  escalation: EscalationModal,
  escalationEnabled: EscalationEnabledModal,
  eula: EulaModal,
  failure: FailureModal,
  failureUpdate: FailureUpdateModal,
  forceLogoutModal: ForceLogoutModal,
  go: GoModal,
  groupMessageStatus: GroupMessageStatusModal,
  joinForum: JoinForumModal,
  joinVoipCallErrorModal: JoinVoipCallErrorModal,
  leaveGroup: LeaveGroupModal,
  leaveTeam: LeaveTeamModal,
  logoutModal: LogoutModal,
  manageLocations: ManageLocationsModal,
  managePatientOrContact: ManagePatientOrContactModal,
  mentionMember: MentionMemberModal,
  messageAttachment: MessageAttachmentModal,
  messageDelete: MessageDeleteModal,
  messageForward: MessageForwardModal,
  messageInfo: MessageInfoModal,
  messageRecall: MessageRecallModal,
  mute: MuteModal,
  newGroup: NewGroupModal,
  newPatientCsvFail: NewPatientCsvModal,
  noCamera: NoCameraConnectionModal,
  oldLeaveTeam: OldLeaveTeamModal,
  onDuty: OnDutyModal,
  optIn: OptInModal,
  optOut: OnDutyModal,
  orgSettingEnabled: OrgSettingEnabledModal,
  ownerRequired: OnDutyModal,
  pager: PagerModal,
  patientAccessCode: SecurityRiskModal,
  patientAdminFailure: PatientAdminFailureModal,
  patientBroadcastCsvFail: PatientBroadcastCsvFailModal,
  patientCsvFail: PatientCsvFailModal,
  patientDelete: PatientDeleteModal,
  patientDOB: SecurityRiskModal,
  patientForwardSuccess: PatientForwardSuccessModal,
  patientProfile: PatientProfileModal,
  patientReferenceDetails: PatientReferenceDetailsModal,
  patientReferenceSelect: PatientReferenceSelectModal,
  patientSaveSuccess: PatientSaveSuccessModal,
  patientsSubmittedCSV: PatientsSubmittedCSVModal,
  priorityMessage: PriorityMessageModal,
  quickReply: QuickReplyModal,
  rejectedFileFormat: RejectedFileFormatModal,
  rejectedFileSize: RejectedFileSizeModal,
  removedFromRoleModal: RemovedFromRoleModal,
  removeEscalationGroup: RemoveEscalationGroupModal,
  removePager: RemovePagerModal,
  removePatientBroadcastListMember: RemovePatientBroadcastListMember,
  removeRoleOrUserLine: RemoveRoleOrUserLineModal,
  removeTag: RemoveTagModal,
  roleScheduler: RolesSchedulerModal,
  rtuWarningScreen: RoleEditorHandoffWarningScreenModal,
  scheduleMessage: ScheduleMessageModal,
  scheduleMessageReview: ScheduleMessageReviewModal,
  success: SuccessModal,
  sukiModal: SukiModal,
  supportedFileTypes: SupportedFileTypesModal,
  tag: TagModal,
  tagSelector: TagSelectorModal,
  tagSelectorEditor: TagSelectorModal,
  tookOverRoleModal: TookOverRoleModal,
  uploadPatientsCsv: UploadPatientsCsvModal,
  uploadPBXLines: UploadPBXLinesModal,
  visitorCall: VisitorCallModal,
  wrongPasswordModal: WrongPasswordModal,
};

type MobxProps = {
  closeModal: () => void;
  currentModalType: string;
  isModalOpen: boolean;
  options: { [key: string]: unknown };
};

type RootModalProps = {};

function RootModal({
  closeModal,
  currentModalType,
  isModalOpen,
  options,
}: RootModalProps & MobxProps) {
  const dispatch = useAppDispatch();
  const openModal = useAppSelector(({ session }) => session.openModal);
  const isReduxModalOpen = useAppSelector(({ session }) => session.isModalOpen);
  const [isOpen, setIsOpen] = useState(false);
  const [currentModal, setCurrentModal] = useState('');
  const [_options, setOptions] = useState({});

  useEffect(() => {
    if (isModalOpen && currentModalType) {
      setCurrentModal(currentModalType);
      setOptions(options);
      setIsOpen(true);
    } else if (isReduxModalOpen && openModal) {
      setCurrentModal(openModal?.name);
      setOptions(openModal?.data || {});
      setIsOpen(true);
    } else {
      setIsOpen(false);
    }
  }, [currentModalType, isModalOpen, isReduxModalOpen, openModal, options]);
  const Modal = COMPONENT_BY_TYPE[currentModal];

  function _closeModal() {
    closeModal();
    dispatch(setModal(undefined));
    dispatch(setMessageBodyInputFocus(true));
  }

  return Modal ? (
    <div style={{ zIndex: 2 }}>
      <Modal closeModal={_closeModal} isOpen={isOpen} options={_options} />
    </div>
  ) : null;
}

export default mobxInjectSelect<RootModalProps, MobxProps>({
  modalStore: ['closeModal', 'currentModalType', 'isModalOpen', 'options'],
})(RootModal);
